import vtkSTLReader from './STLReader';
import vtkDracoReader from './DracoReader';
import vtkSTLWriter from './STLWriter';

export default {
  vtkSTLReader,
  vtkDracoReader,
  vtkSTLWriter,
};
